import { MapFilter } from "../MapFilter";
import { MarketplaceListItem } from "../MarketplaceListItem";
import { ICacheStorage } from "./ICacheStorage";

export class MarketplaceListItemsCacheStorage implements ICacheStorage<MarketplaceListItem> {
    private readonly storage: Map<string, MarketplaceListItemsChunk>;
    
    public constructor() {
        this.storage = new Map();
    }

    public cacheData(filter: MapFilter, items: MarketplaceListItem[], force: boolean): void {
        const key = this.constructKey(filter);
        if (!this.storage.has(key)) {
            this.storage.set(key, new MarketplaceListItemsChunk());
        }        
        const chunk = this.storage.get(key);
        chunk.updateItems(filter.offset, items, force);
    }
    
    public getCachedData(filter: MapFilter): MarketplaceListItem[] {
        const key = this.constructKey(filter);
        if (!this.storage.has(key)) {
            return [];
        }
        const chunk = this.storage.get(key);
        const items: MarketplaceListItem[] = [];
        chunk.tryGetItems(filter.offset, filter.limit, items);
        return items;
    }

    private constructKey(filter: MapFilter): string {
        return filter.zipCode != undefined ? `area-${filter.area}-zip-${filter.zipCode}` : `area-${filter.area}`;
    }
}

class MarketplaceListItemsChunk {
    
    private readonly items: Map<number, MarketplaceListItem>;

    public constructor() {
        this.items = new Map();
    }

    public updateItems(offset: number, items: MarketplaceListItem[], force: boolean): void {
        if (force)
        {
            this.items.clear();
        }
        for (let i = 0; i < items.length; i++) {
            if (this.items.has(offset + i)) {
                continue;
            }
            this.items.set(offset + i, items[i]);
        }
    }

    public tryGetItems(offset: number, limit: number, out: MarketplaceListItem[]): boolean {
        if (this.items.size < limit || !this.items.has(offset) || !this.items.has(offset + limit - 1)) {
            return false;
        }
        for (let index = offset; index < offset + limit; index++) {
            if (!this.items.has(index)) {
                out.length = 0;
                return false;
            }
            out.push(this.items.get(index));
        }
        return true;
    }
}
